import React from 'react';
import { ResponsiveBar } from '@nivo/bar';
import { VideoMetaData } from '@/interfaces/video';
import styles from './sentiment.module.css';

interface ISentiment {
	entry: number;
	negative: number;
	neutral?: number;
	positive: number;
	text: string;
	negativeColor?: string;
	neutralColor?: string;
	positiveColor?: string;
}

interface IProps {
	id: string;
	meta: VideoMetaData;
	data: any[];
}

const ChartSentiment: React.FC<IProps> = ({ id, meta, data }) => {
	return (
		<div style={{ height: 400 }}>
			<ResponsiveBar
				animate={false}
				data={data}
				maxValue={100}
				minValue={-100}
				keys={['negative', 'positive']}
				indexBy="entry"
				margin={{ top: 50, right: 15, bottom: 50, left: 40 }}
				padding={0.3}
				valueScale={{ type: 'linear' }}
				indexScale={{ type: 'band', round: false }}
				// @ts-ignore
				colors={(d) => d.data[d.id + 'Color']}
				borderColor={{ theme: 'labels.text.fill' }}
				axisTop={null}
				axisRight={null}
				axisBottom={null}
				enableGridX={false}
				enableGridY={true}
				enableLabel={false}
				labelSkipWidth={12}
				labelSkipHeight={12}
				labelTextColor={{
					from: 'color',
					modifiers: [['darker', 1.6]],
				}}
				legends={[
					{
						dataFrom: 'keys',
						anchor: 'bottom-right',
						direction: 'row',
						justify: false,
						translateX: 35,
						translateY: 30,
						itemsSpacing: 2,
						itemWidth: 100,
						itemHeight: 20,
						itemDirection: 'left-to-right',
						itemOpacity: 0.85,
						symbolSize: 20,
						effects: [
							{
								on: 'hover',
								style: {
									itemOpacity: 1,
								},
							},
						],
					},
				]}
				tooltip={(p) => <div className={styles.barChartHover}>{p.data.text}</div>}
				onClick={(d) => {
					window.open(`${meta.url}&t=${Math.round(+d.indexValue - 2)}s`);
				}}
			/>
		</div>
	);
};

export default React.memo(ChartSentiment);
